import React from "react";

import { Grid } from "@mui/material";

import DisplayPropertiesCard from "@covertree/ui/content/DisplayPropertiesCard";
import { formatAwsDateString } from "@covertree/utils";

import { RenewalDetailsContentProps } from "@routing/routes/Renewals/RenewalDetails/RenewalDetailsContent/ContentTabs/types";

export function NonRenewalIssuedDetails({
  renewal,
}: RenewalDetailsContentProps) {
  return (
    <Grid item xs={12}>
      <DisplayPropertiesCard
        properties={[
          {
            label: "Non-renewal issue date",
            value: renewal?.nonRenewalIssueDate
              ? formatAwsDateString(renewal.nonRenewalIssueDate)
              : "N/A",
            gridSize: 6,
          },
          {
            label: "Non-renewal reason",
            value: renewal?.nonRenewalReason || "None",
            gridSize: 6,
          },
          {
            label: "Non-renewal description",
            value: renewal?.description || "None",
            gridSize: 12,
          },
        ]}
      />
    </Grid>
  );
}
